// extracted by mini-css-extract-plugin
export var content = "Container-module__content___RF5uw";